<div id="toolbar-menu" class="d-none d-lg-block">
  <!-- Sidebar Toggle Button -->
  @if (showMe) {
    <button mat-icon-button (click)="sidenav.toggle()" aria-label="Open sidebar" class="d-inline-block">
      <mat-icon>menu</mat-icon>
    </button>
  }

  <!-- Logo Container -->
  <div class="fg-logo-container d-inline-block" role="img" aria-label="logo"></div>
  @if (toolbarSettings.showAppTitle) {
    <span class="topAppTitle">{{getAppName()}}</span>
  }
</div>

<div id="toolbar-options" class="fg-main-tool-bar">
  @if (appConfigSetting.customToolbarConfig) {
    @for (toolbarItem of customToolbarData; track toolbarItem; let idx = $index) {
      @if (idx < customToolbarConfigs.config.noOfIconsToDisplay && (userService.isUserLoggedIn() || toolbarItem.publicAccess)) {
        <button (click)="goToToolbarItemDetail(toolbarItem)" type="button" [aria-label]="toolbarItem.name"
          mat-button [matTooltip]="toolbarItem.description" matTooltipPosition="below"
          [ngClass]="toolbarItem.customClass ? toolbarItem.customClass : ''">
          @if (toolbarItem.matIcon) {
            <mat-icon
            [aria-label]="toolbarItem.name">{{toolbarItem.matIcon}}</mat-icon>
          }
          @if (toolbarItem.faIcon) {
            <i [class]="toolbarItem.faIcon" aria-hidden="true"></i>
          }
        </button>
      }
      @if (idx == customToolbarConfigs.config.noOfIconsToDisplay  && (userService.isUserLoggedIn() || toolbarItem.publicAccess)) {
        <button type="button" mat-button [matMenuTriggerFor]="moreMenu"
          [matTooltip]="customToolbarConfigs.config.moreDescription" matTooltipPosition="below">
          @if (customToolbarConfigs.config.moreMatIcon) {
            <mat-icon
            aria-label="More Icon">{{customToolbarConfigs.config.moreMatIcon}}</mat-icon>
          }
          @if (customToolbarConfigs.config.moreFaIcon) {
            <i [class]="customToolbarConfigs.config.moreFaIcon"
            aria-hidden="true"></i>
          }
        </button>
        <mat-menu #moreMenu="matMenu" class="fg-more-toolbar-panel" backdropClass="fg-more-toolbar-menu"
          xPosition="before">
          <div class="fg-more-toolbar-container-panel">
            @for (toolbarItem of customToolbarData.slice(customToolbarConfigs.config.noOfIconsToDisplay); track toolbarItem) {
              <div>
                <button (click)="goToToolbarItemDetail(toolbarItem)" type="button"
                  [aria-label]="toolbarItem.name" mat-button [matTooltip]="toolbarItem.description"
                  matTooltipPosition="after"
                  [ngClass]="toolbarItem.customClass ? toolbarItem.customClass : ''">
                  <div class="fg-toolbar-menu-icon-container d-inline-block">
                    @if (toolbarItem.matIcon) {
                      <mat-icon
                      [aria-label]="toolbarItem.name">{{toolbarItem.matIcon}}</mat-icon>
                    }
                    @if (toolbarItem.faIcon) {
                      <i [class]="toolbarItem.faIcon"
                      aria-hidden="true"></i>
                    }
                  </div>
                  <span class="fg-more-toolbar-items ml-1">{{toolbarItem.name}}</span>
                </button>
              </div>
            }
          </div>
        </mat-menu>
      }
    }
  }

  @if (toolbarSettings.showHomeBtn) {
    <a type="link" aria-label="Home" mat-icon-button href="/launcher">
      <mat-icon aria-label="Home icon">home</mat-icon>
    </a>
  }
  <div class="launcher">
    @if (toolbarSettings.showLauncher) {
      <fg-app-launcher class="launcher"></fg-app-launcher>
    }
  </div>
  <button mat-icon-button [matMenuTriggerFor]="languageMenu" matTooltipPosition="below">
    <mat-icon>language</mat-icon>

  </button>
  <mat-menu #languageMenu="matMenu" class="fg-more-toolbar-panel" backdropClass="fg-more-toolbar-menu" xPosition="before">
    <button mat-menu-item (click)="changeLanguage('en')">
      <div class="menu-item-flex"  [dir]="appDirection">
        <span class="mat-mdc-menu-item-text">🇬🇧 English</span>
        @if (selectedLanguage === 'en') {
          <mat-icon class="menu-tick-icon">check</mat-icon>
        }
      </div>
    </button>

    <button mat-menu-item (click)="changeLanguage('ta')">
      <div class="menu-item-flex"  [dir]="appDirection">
        <span class="mat-mdc-menu-item-text">அ Tamil</span>
        @if (selectedLanguage === 'ta') {
          <mat-icon class="menu-tick-icon">check</mat-icon>
        }
      </div>
    </button>

    <button mat-menu-item (click)="changeLanguage('ar')">
      <div class="menu-item-flex"  [dir]="appDirection">
        <span class="mat-mdc-menu-item-text">؈ Arabic</span>
        @if (selectedLanguage === 'ar') {
          <mat-icon class="menu-tick-icon">check</mat-icon>
        }
      </div>
    </button>
  </mat-menu>

  <span class="spacer"></span>

  <button mat-icon-button (click)="triggerSettingsDrawer()" aria-label="Settings">
    <mat-icon>manage_accounts</mat-icon>
  </button>

</div>
